import { useEffect } from 'react';
import { getDeviceType } from '../utils/common';
import safeWindow from '../utils/safeWindows';
import { runSetDeviceType } from '../context/chat-widget-context/reducers/actions/runs';
import { useChatWidgetContext } from '../context/chat-widget-context/chatWidgetContext';

export const useDeviceType = () => {
  const { state, dispatch } = useChatWidgetContext();

  useEffect(() => {
    const handleResize = () => {
      const newDeviceType = getDeviceType(safeWindow.innerWidth);
      if (newDeviceType !== state.deviceType) {
        dispatch(runSetDeviceType(newDeviceType));
      }
    };

    handleResize();

    safeWindow.addEventListener('resize', handleResize);

    return () => {
      safeWindow.removeEventListener('resize', handleResize);
    };
  }, [state.deviceType]);
};
